import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0210e8ef&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=0210e8ef&prod&lang=scss"
import style1 from "./home.vue?vue&type=style&index=1&id=0210e8ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210e8ef",
  null
  
)

export default component.exports